import { useSelector } from 'react-redux';

import { CreditsPill, DurationPill } from '@/components';
import { ComplianceTypes } from '@/constants';
import { selectUserCompliance } from '@/store';

interface CreditsDurationInfoProps {
  credits: number;
  duration: number;
  durationPlayed?: number;
}

export const CreditsDurationInfo = ({
  credits,
  duration,
  durationPlayed,
}: CreditsDurationInfoProps) => {
  const compliance = useSelector(selectUserCompliance);

  if (compliance !== ComplianceTypes.CPE || durationPlayed! > 0) {
    return <DurationPill duration={duration} longForm={false} />;
  }

  return <CreditsPill credits={credits} />;
};
